import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import GlobalContext from "../../../context/GlobalContext";
import { userService } from "../../../services/CommonServices";
import ReactPaginate from "react-paginate";
import Loader from "../../Loader/Loader";

const CustomersList = () => {
  let navigate = useNavigate();
  const globalData = useContext(GlobalContext);

  const [res, setRes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const itemsPerPage = 10;

  useEffect(() => {
    get_customers_list(0); // Initial fetch for the first page
  }, []);

  function get_customers_list(page) {
    const headers = {
      Authorization: globalData.token,
    };

    const params = {
      page,
      size: itemsPerPage,
      search: searchQuery, // Passing the search term for filtering
    };

    userService
      .customers_list_api(headers, params)
      .then((response) => {
        if (response.status === 200) {
          setRes(response.data.data);
          setTotalPages(Math.ceil(response.data.total / 10)); // Assuming total pages are provided by the server
          setIsLoading(false);
        }
      })
      .catch((error) => {
        alert(error);
        setIsLoading(false);
        if (error.response?.status === 401) {
          globalData.set_token("");
          globalData.set_org_id("");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("org_id");
          navigate("/login");
        }
      });
  }

  const handleSearch = () => {
    setIsLoading(true);
    get_customers_list(0); // Reset to the first page when searching
  };

  const handlePageClick = (event) => {
    const selectedPage = event.selected;
    setIsLoading(true);
    get_customers_list(selectedPage); // Fetch data for the selected page
  };

  return (
    <div className="content_area">
      <div>
        {isLoading && <Loader />}
      </div>
      <div className="tables_area">
        <div className="title-box">
          <h2 className="pull-left">Customers List</h2>
          <div className="clear"></div>
        </div>
        <div className="filter-box">
          <input
            type="text"
            placeholder="Search by name, phone, or email"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button onClick={handleSearch}>Search</button>
        </div>
        <div className="white_box">
          <div className="table-responsive">
            <table width="100%" cellSpacing="0" cellPadding="0">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Email</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Country Code</th>
                  <th>Phone Number</th>
                  <th>Street Address</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip Code</th>
                </tr>
              </thead>
              <tbody>
                {res.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.email}</td>
                    <td>{item.firstName}</td>
                    <td>{item.lastName}</td>
                    <td>{item.countryCode}</td>
                    <td>{item.phoneNumber}</td>
                    <td>{item.streetAddress}</td>
                    <td>{item.city}</td>
                    <td>{item.state}</td>
                    <td>{item.zipCode}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <ReactPaginate
            breakLabel="..."
            nextLabel="next >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={totalPages}
            previousLabel="< previous"
            renderOnZeroPageCount={null}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomersList;